/**
 * ツアー見どころ（Itinerary）アコーディオン機能
 */
(function() {
  'use strict';

  // DOMの読み込み完了を待つ
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initItineraryAccordion);
  } else {
    initItineraryAccordion();
  }

  function initItineraryAccordion() {
    // ツアー見どころセクションを取得
    const itinerarySection = document.querySelector('.experience-itinerary');
    
    if (!itinerarySection) {
      console.log('Itinerary section not found');
      return;
    }

    // ヘッダーとコンテンツを取得
    const header = itinerarySection.querySelector('.experience-itinerary__header');
    const content = itinerarySection.querySelector('.experience-itinerary__timeline');
    
    if (!header || !content) {
      console.log('Header or content not found');
      return;
    }

    // HTML構造を調整
    setupAccordionStructure(itinerarySection, header, content);

    // クリックイベントを設定
    header.addEventListener('click', function() {
      toggleAccordion(itinerarySection);
    });

    // キーボードアクセシビリティ
    header.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleAccordion(itinerarySection);
      }
    });

    console.log('Itinerary accordion initialized');
  }

  function setupAccordionStructure(section, header, content) {
    // ヘッダーをクリック可能にする
    header.setAttribute('role', 'button');
    header.setAttribute('aria-expanded', 'false');
    header.setAttribute('tabindex', '0');
    
    // ヘッダーの内容をラップ
    const headerContent = document.createElement('div');
    headerContent.className = 'experience-itinerary__header-content';
    
    // 既存の要素を移動
    const heading = header.querySelector('.experience-itinerary__heading');
    const subheading = header.querySelector('.experience-itinerary__subheading');
    
    if (heading) headerContent.appendChild(heading);
    if (subheading) headerContent.appendChild(subheading);
    
    // トグルアイコンを作成
    const toggle = document.createElement('div');
    toggle.className = 'experience-itinerary__toggle';
    toggle.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
    toggle.setAttribute('aria-hidden', 'true');
    
    // ヘッダーを再構築
    header.innerHTML = '';
    header.appendChild(headerContent);
    header.appendChild(toggle);
    
    // コンテンツをラップ
    const contentWrapper = document.createElement('div');
    contentWrapper.className = 'experience-itinerary__content';
    contentWrapper.setAttribute('role', 'region');
    contentWrapper.setAttribute('aria-labelledby', 'itinerary-heading');
    
    // 既存のコンテンツを移動
    contentWrapper.appendChild(content);
    section.appendChild(contentWrapper);
    
    // 見出しにIDを追加
    if (heading) {
      heading.id = 'itinerary-heading';
    }
  }

  function toggleAccordion(section) {
    const isOpen = section.classList.contains('is-open');
    const header = section.querySelector('.experience-itinerary__header');
    
    if (isOpen) {
      // 閉じる
      section.classList.remove('is-open');
      header.setAttribute('aria-expanded', 'false');
    } else {
      // 開く
      section.classList.add('is-open');
      header.setAttribute('aria-expanded', 'true');
    }
  }

  // 印刷時は常に開いた状態にする
  window.addEventListener('beforeprint', function() {
    const section = document.querySelector('.experience-itinerary');
    if (section) {
      section.classList.add('is-open');
    }
  });

})();